(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentGoal'
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AgentGoals/form', function onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load($form)
	{
		$('#agentgoal-agent_goal_type_id').change(function typeChanged() {
			var is_vendor_specific = isVendorSpecific();
			var $goal_label        = $('.goal-amount-field').find('label').first();

			if ($(this).val() === "1") { // performance
				$('.periods').removeClass('hidden');

				showDefaultFields();

				$goal_label.html('<span class="required"></span> Goal');
				$('.period-or-benchmark').removeClass('hidden');
				$('#agentgoal-period_or_benchmark-0')
					.prop('checked', true)
					.trigger('change')
					.parent('label').addClass('active');

				$('#agentgoal-period_or_benchmark-1')
					.prop('checked', false)
					.parent('label').removeClass('active');

				if ($('#agentgoal-metric').val() === 'units' || is_vendor_specific === true) {
					$('.component-types').addClass('hidden');
					$('.supplier-type').addClass('hidden');
				} else {
					$('.component-types').removeClass('hidden');

					if ($('#agentgoal-component_type').val() === 'cruise') {
						$('.supplier-type').removeClass('hidden');
					}
				}
			} else if ($(this).val() === "2") { // growth
				showDefaultFields();

				$goal_label.html('<span class="required"></span> Goal %');

				$('.period-or-benchmark').addClass('hidden');
				$('.benchmark-field').addClass('hidden');
				$('.quarters').addClass('hidden');
				$('.periods').addClass('hidden');
				$('.num-months').addClass('hidden');
				$('.monthly-goals').addClass('hidden');

				hideAllSpecificMonths();
				hideMonths();
				$('.year').removeClass('hidden');

				$('#agentgoal-period').val('');

				$('.month-value').each(function clearMonthlyGoals() {
					$(this).val('');
				});

				$('.specific-date-value').each(function clearSpecifcDates() {
					$(this).val('');
				});

				$('.specific-amount-value').each(function clearSpecifcAmounts() {
					$(this).val('');
				});

				if ($('#agentgoal-metric').val() === 'units'|| is_vendor_specific === true) {
					$('.component-types').addClass('hidden');
					$('.supplier-type').addClass('hidden');
				} else {
					$('.component-types').removeClass('hidden');

					if ($('#agentgoal-component_type').val() === 'cruise') {
						$('.supplier-type').removeClass('hidden');
					}
				}
			} else {
				$('.goal-fields').each(function showFields() {
					$(this).addClass('hidden');
				});

				$('.month-value').each(function clearMonthlyGoals() {
					$(this).val('');
				});

				$('.specific-date-value').each(function clearSpecifcDates() {
					$(this).val('');
				});

				$('.specific-amount-value').each(function clearSpecifcAmounts() {
					$(this).val('');
				});

				$goal_label.html('<span class="required"></span> Goal');

				$('.period-or-benchmark').addClass('hidden');
				$('.benchmark-field').addClass('hidden');
				$('.component-types').addClass('hidden');
				$('.quarters').addClass('hidden');
				$('.agentgoal-component_type').val('');

				$('.vendors').addClass('hidden');
				$('.supplier-type').addClass('hidden');
				$('.year').addClass('hidden');
			}
		});

		$('#agentgoal-period').change(function periodChange() {
			if ($(this).val() === 'annual') {
				$('.num-months').addClass('hidden');
				$('.year').removeClass('hidden');
				$('.quarters').addClass('hidden');

				if ($('#agentgoal-agent_goal_type_id').val() === '1') {
					$('.monthly-goals').removeClass('hidden');
				}

				hideAllSpecificMonths();
			} else if ($(this).val() === 'month') {
				updateSpecificMonthsCurrency();

				$('.num-months').removeClass('hidden');
				$('.monthly-goals').addClass('hidden');
				$('.year').addClass('hidden');
				$('.quarters').addClass('hidden');
			} else if ($(this).val() === 'quarter') {
				$('.num-months').addClass('hidden');
				$('.monthly-goals').addClass('hidden');

				hideMonths();
				hideAllSpecificMonths();

				$('.year').removeClass('hidden');
				$('.quarters').removeClass('hidden');
			} else {
				$('.num-months').addClass('hidden');
				$('.monthly-goals').addClass('hidden');
				$('.year').addClass('hidden');
				$('.quarters').addClass('hidden');

				hideMonths();
				hideAllSpecificMonths();
			}

			resetAmounts();
		});

		$('#agentgoal-goal_year').change(function yearChanged() {
			if ($('#agentgoal-monthly_goals').prop('checked') === true) {
				adjustAvailableMonths();
			}
		});

		$('#agentgoal-monthly_goals').click(function monthlyGoalsPressed() {
			if ($(this).prop('checked') === true) {
				$('.months').each(function showMonths() {
					$(this).removeClass('hidden');
				});

				adjustAvailableMonths();
			} else {
				hideMonths();
			}
		});

		$('#agentgoal-num_months').change(function numMonths() {
			var num_months = parseInt($(this).val()),
				i          = 0;

			hideAllSpecificMonths();

			$('#agentgoal-num_months').val(num_months);

			if (num_months > 0) {
				for (i=1;i<=12;i++) {
					if (i <= num_months) {
						$('#specifc-month-' + i).removeClass('hidden');
					}
				}

				updateGoalTotal();
			} else {
				hideAllSpecificMonths();
			}
		});

		$('.add-to-goal').keyup(function addToGoal() {
			updateGoalTotal();
		});

		$('#agentgoal-component_type').change(function componentTypeSelected() {
			var component_type = $(this).val();
			var supplier_type  = '';
			var url            = '';

			if (component_type === '') {
				$('.vendors').addClass('hidden');
				$('.supplier-type').addClass('hidden');
			} else {
				url = '/AgentGoals/getVendorListByType/' + component_type;

				$('.vendors').removeClass('hidden');
				$('.supplier-type').addClass('hidden');

				if (component_type === 'cruise') {
					$('.supplier-type').removeClass('hidden');

					supplier_type = $('#agentgoal-supplier_type').val();

					if (supplier_type !== '') {
						url += '/' + supplier_type;
					}
				}

				Adzuki.Ajax.get(url).then(function success(response) {
					var results = response.vendors;

					$("#agentgoal-vendor_ids").html(results);
					$("#agentgoal-vendor_ids").selectpicker('refresh');
				});
			}
		});

		$('#agentgoal-metric').change(function metricChanged() {
			var metric_type = $(this).val();

			if (metric_type === 'units') {
				$('.component-types').addClass('hidden');
				$('.supplier-type').addClass('hidden');
			} else {
				$('.component-types').removeClass('hidden');

				if ($('#agentgoal-component_type').val() === 'cruise') {
					$('.supplier-type').removeClass('hidden');
				}
			}

			$('#agentgoal-amount_type').empty();
			$('#agentgoal-amount_type').append('<option value="">Please Select</option>');

			Adzuki.Ajax.get('/AgentGoals/getMeasurementsByMetric/' + metric_type)
			.then(function success(response) {
				$.each(response, function onEachProduct(code, name) {
					var markup = '';
					markup += '<option value="' + code + '">';
					markup += name + '</option>';

					$('#agentgoal-amount_type').append(markup);
				});
			});
		});

		$('#agentgoal-amount_type').change(function checkIfSpecificToVendor() {
			Adzuki.Ajax.get('/AgentGoals/isVendorSpecific/' + $(this).val())
			.then(function success(response) {
				if (response.vendor_specific === true) {
					$('.component-types').addClass('hidden');
					$('.supplier-type').addClass('hidden');
				} else {
					$('.component-types').removeClass('hidden');

					if ($('#agentgoal-component_type').val() === 'cruise') {
						$('.supplier-type').removeClass('hidden');
					}
				}
			});
		});

		$('#agentgoal-measurement').change(function showHideTravelType() {
			var vendor_specific_list  = $('#agentgoal-vendor_specific').val();
			var percentage_based_list = $('#agentgoal-percentage_based').val();
			var measurement_type      = $('#agentgoal-measurement :selected').parent().attr('label');
			var vendor_specifics      = null;
			var percentages_based     = null;
			var is_vendor_specific    = false;
			var is_percentage_based   = false;
			var amount_found          = false;
			var i                     = 0;

			percentages_based = percentage_based_list.split("|");
			vendor_specifics  = vendor_specific_list.split("|");

			for (i=0;i<vendor_specifics.length;i++) {
				if ($(this).val() === vendor_specifics[i]) {
					is_vendor_specific = true;
				}
			}

			for (i = 0; i < percentages_based.length; i++) {
				if ($(this).val() === percentages_based[i]) {
					is_percentage_based = true;
				}
			}

			updateSpecificMonthsCurrency();

			if (is_vendor_specific === true || measurement_type === 'Units') {
				$('.component-types').addClass('hidden');
				$('.vendors').addClass('hidden');
				$('.supplier-type').addClass('hidden');
				$('#agentgoal-component_type').val('');
				$("#agentgoal-vendor_ids").html('');
				$('#agentgoal-vendor_ids').selectpicker('refresh');
			} else {
				$('.component-types').removeClass('hidden');

				if ($('#agentgoal-component_type').val() === 'cruise') {
					$('.supplier-type').removeClass('hidden');
				}
			}

			// this is a percentage based goal, remove the Amount option
			if (is_percentage_based === true) {
				if ($('#agentgoal-agent_goal_type_id').val() === '1') {
					$('#agentgoal-agent_goal_type_id').val('').trigger('change');
				}

				$('#agentgoal-agent_goal_type_id option[value="1"]').remove();
			} else {
				// add it back if it's not there
				$('#agentgoal-agent_goal_type_id option').each(function onEachOption(idx, el) {
					if ($(el).val() === '1') {
						amount_found = true;
						return true;
					}
				});

				if (amount_found === false) {
					$('#agentgoal-agent_goal_type_id').append('<option value="1">Amount</option>');
				}
			}
		});

		$('#agentgoal-show_on_dashboard').change(function showOnDashboardChange(e) {
			var $replace_goals = $('.replace-goals');

			if ($replace_goals.length > 0) {
				if ($(this).is(':checked')) {
					$replace_goals.removeClass('hidden');
				} else {
					$replace_goals.addClass('hidden');
				}
			}
		});

		$('.pb-radio').change(function onPeriodOrBenchmarkChange(e) {
			var measurement = $(this).val();

			$('#agentgoal-period').val('').trigger('change');

			if (measurement === 'period') {
				$('.periods').removeClass('hidden');
				$('.benchmark-field').addClass('hidden');
			} else if (measurement === 'benchmark') {
				$('#agentgoal-benchmark').val('').trigger('change');
				$('.periods').addClass('hidden');
				$('.benchmark-field').removeClass('hidden');
			}
		});

		$('#agentgoal-supplier_type').change(function supplierTypeChanged(e) {
			var component_type = $('#agentgoal-component_type').val();
			var supplier_type  = $(this).val();
			var url            = '/AgentGoals/getVendorListByType/' + component_type;

			if (component_type === '' || component_type !== 'cruise') {
				return;
			}

			if (supplier_type !== '') {
				url += '/' + supplier_type;
			}

			Adzuki.Ajax.get(url).then(function success(response) {
				var results = response.vendors;

				$('#agentgoal-vendor_ids').html(results);
				$('#agentgoal-vendor_ids').selectpicker('refresh');
			});
		});
	};

	function showDefaultFields() {
		$('.goal-fields').each(function showFields() {
			$(this).removeClass('hidden');
		});
	}

	function adjustAvailableMonths() {
		var i         = 0,
			d         = new Date(),
			cur_month = parseInt(d.getMonth()) + 1,
			cur_year  = d.getFullYear(),
			year      = $('#agentgoal-goal_year').val();

		if (parseInt(cur_year) === parseInt(year)) {
			for (i=1;i<=12;i++) {
				if (i < parseInt(cur_month)) {
					$('#month-' + i).addClass('hidden');
				}
			}
		} else {
			$('.months').each(function showMonths() {
				$(this).removeClass('hidden');
			});
		}
	}

	function hideMonths() {
		$('.months').each(function hideMonths() {
			$(this).addClass('hidden');
		});

		$('.month-value').each(function removeValues() {
			$(this).val('');
		});
	}

	function hideAllSpecificMonths() {
		var date_counter = 0,
			amt_counter  = 0,
			num_months   = parseFloat($('#agentgoal-num_months').val());

		$('.specific-months').each(function hideEm() {
			$(this).addClass('hidden');
		});

		$('#agentgoal-num_months').val('');


		$('.specific-date-value').each(function resetDateVal() {
			date_counter++;

			if (date_counter > num_months) {
				$(this).val('');
				$(this).data('DateTimePicker').clear();
			}
		});

		$('.specific-amount-value').each(function resetAmountVal() {
			amt_counter++;

			if (amt_counter > num_months) {
				$(this).val('');
			}
		});
	}

	function resetAmounts() {
		$('.add-to-goal').each(function sumIt() {
			$(this).val('');
		});
	}

	function updateGoalTotal() {
		var total = 0;
		$('.add-to-goal').each(function sumIt() {
			if ($(this).val() !== '') {
				total += Number($(this).val());
			}
		});

		$('#agentgoal-amount').val(total);
	}

	function updateSpecificMonthsCurrency() {
		var unit_based_list = $('#agentgoal-unit_based').val();
		var units_based     = null;
		var is_unit_based   = false;
		var i               = 0;

		units_based = unit_based_list.split("|");

		for (i = 0; i < units_based.length; i++) {
			if ($('#agentgoal-measurement').val() === units_based[i]) {
				is_unit_based = true;
			}
		}

		if (is_unit_based) {
			$('.specific-months').each(function onEachSpecMonth(i, elem) {
				var $month = $(elem);
				$month.find('.month-amounts .fas').first()
					.removeClass('adzicon-usd fa-dollar-sign')
					.addClass('adzicon-hashtag fa-hashtag');
			});
		} else {
			$('.specific-months').each(function onEachSpecMonth(i, elem) {
				var $month = $(elem);
				$month.find('.month-amounts .fas').first()
					.removeClass('adzicon-hashtag fa-hashtag')
					.addClass('adzicon-usd fa-dollar-sign');
			});
		}
	}

	function isVendorSpecific(obj) {
		var vendor_specifc_list = $('#agentgoal-vendor_specific').val(),
			vendor_specifics    = vendor_specifc_list.split("|"),
			i                   = 0,
			is_vendor_specific  = false;

		for (i=0;i<vendor_specifics.length;i++) {
			if ($('#agentgoal-measurement').val() === vendor_specifics[i]) {
				is_vendor_specific = true;
			}
		}

		return is_vendor_specific;
	}
}(jQuery, window.Adzuki || {}));
